export default __webpack_public_path__ + "assets/svg/excercises_white.65da4840da55892a46c59c84b35d2d72.svg";